import _EmailVerificationPage from "./components/EmailVerificationPage"
import _PasswordUpdatePage from "./components/PasswordUpdatePage"

export const EmailVerificationPage = _EmailVerificationPage;
export const PasswordUpdatePage = _PasswordUpdatePage;